module.exports = __webpack_public_path__ + "static/media/uz.5cee4a88.svg";